import DOMPurify from 'dompurify';

// a[target="_blank"] にはタブナビング対策として rel="noopener noreferrer" を強制付与する。
// afterSanitizeAttributes で setAttribute した値は ALLOWED_ATTR に rel が無くても保持される。
DOMPurify.addHook('afterSanitizeAttributes', (node) => {
  if (node.tagName === 'A' && node.getAttribute('target') === '_blank') {
    node.setAttribute('rel', 'noopener noreferrer');
  }
});

/**
 * 帳票テンプレのプレビュー表示の無害化を行う
 *
 * サーバ(render_html_by_excel / SPL_PhpExcelReader)が生成する Excel 由来の表 HTML を無害化しつつ、
 * プレビューに必要な最小権限の表構造・セル書式だけを許可する
 *
 * 許可集合は保存済み plan_templates.html(実データ)に出現する実タグ/属性を根拠に決定する:
 * - 実出現タグ: table/tbody/tr/td/br/nobr（＋プレビュー時に previewPlanHTML が項目名として足す span）
 * - 実出現属性: style/class/colspan/rowspan/cellspacing ＋ data-*(data-field-name)
 * thead/th/colgroup/col/a[href] 等は現データには無いが .xls 経路(render_html_by_excel)が出力しうる安全な
 * 表構造なので防御的に残す。img / iframe / script は許可しない（`<img onerror>` 等を丸ごと除去する）。
 *
 * - style: 罫線・背景色・文字色・列幅は Excel 変換が style で出力するため保持必須。
 * - data-*(data-field-name 等): セル判定・プレビュー組み立てが参照するため ALLOW_DATA_ATTR で保持する。
 * - on* / javascript: href / 許可外タグ・属性は DOMPurify により除去される。
 * - a[target="_blank"]: タブナビング対策で rel="noopener noreferrer" を afterSanitizeAttributes で付与する。
 *
 * @param content 無害化対象の HTML 文字列
 * @returns プレビュー表示に安全な HTML 文字列
 */
export function sanitizePreviewHtml(content: string): string {
  return DOMPurify.sanitize(content, {
    ALLOWED_TAGS: [
      'table',
      'thead',
      'tbody',
      'tfoot',
      'tr',
      'td',
      'th',
      'colgroup',
      'col',
      'a',
      'span',
      'div',
      'br',
      'nobr',
      'b',
      'strong',
      'i',
      'em',
      'u',
      'p',
    ],
    ALLOWED_ATTR: ['class', 'style', 'colspan', 'rowspan', 'cellspacing', 'href', 'target'],
    ALLOW_DATA_ATTR: true,
  });
}
